export default "__VITE_ASSET__BBD5FaZM__"